export default "__VITE_ASSET__943aeac4__"